// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1966":"55cc57da57d5471d","3899":"99aa94815cd256e5"}[chunkId] + ".js";
};